/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import Moment from 'react-moment';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';
import type TypeForm from 'forms/_.extend';

import Loading from 'components/Loading/Loading';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ElectroCheckList from 'forms/components/inputs/ElectroCheckList/ElectroCheckList';

import endpoints from 'api/endpoints';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  actionDrawerStore: TypeActionDrawerStore,
  project: Object,
  projectDetailsStore: Object,
  form: TypeForm,
  user: *,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'projectDetailsStore')
@observer
export default class ReassignLeadForm extends React.Component<*> {
  render(): React.Fragment {
    const { t, project, user, form, projectDetailsStore }: TypeProps = this.props;

    const projectDetails: Object = project.trading_account ? project : projectDetailsStore.details;

    const lead: Object = projectDetails.project_lead;

    const getChildData: Function = (child: string, val: string) => {
      return typeof projectDetails[child] === 'undefined' ? null : projectDetails[child][val];
    };

    const startDate: * = <Moment date={projectDetails.start_date} format="MMMM DD, YYYY" />;
    const endDate: * = <Moment date={projectDetails.end_date} format="MMMM DD, YYYY" />;

    const projectInfo: Array<*> = [
      [
        t('general:trading_account'),
        `${getChildData('trading_account', 'name')} ${getChildData(
          'trading_account',
          'account_no'
        )}`,
      ],
      [t('general:projects.labels.code'), projectDetails.code],
      [t('general:projects.labels.name'), projectDetails.name],
      [t('general:projects.labels.start_date'), startDate],
      [t('general:projects.labels.end_date'), endDate],
    ];

    if (!projectDetailsStore.details.trading_account) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:projects.labels.details')}
          >
            <ActionDrawerTable data={projectInfo} />
          </ActionDrawerBlock>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:projects.labels.current_lead')}
          >
            {`${lead.first_name} ${lead.last_name}`}
          </ActionDrawerBlock>
          <ElectroCheckList
            field={form.$('reassignProjectTo.assigneeId')}
            type="radio"
            heading={form.$('reassignProjectTo').label}
            endpoint={`${endpoints.accounts}/${getChildData('trading_account', 'id')}/users`}
            enableSearch={true}
            searchKeys={['first_name', 'last_name']}
            exclude={[getChildData('project_lead', 'id')]}
            customResponse={(resp: Object) => {
              let arr: Array<Object> = [];

              for (const key: string in resp) {
                if (Object.prototype.hasOwnProperty.call(resp, key)) {
                  arr = arr.concat(resp[key]);
                }
              }

              return arr;
            }}
            primaryLiteral={(item: Object) => {
              return item.id === user.id ? (
                <React.Fragment>
                  <strong>{t('general:me')}</strong>
                  &nbsp;({`${item.first_name} ${item.last_name}`})
                </React.Fragment>
              ) : (
                `${item.first_name} ${item.last_name}`
              );
            }}
            secondaryLiteral={(item: Object) => (
              <React.Fragment>
                Current role: <strong>{t(`general:roles.${item.role_id}`)}</strong>
              </React.Fragment>
            )}
          />
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.reassign_lead')} />
      </React.Fragment>
    );
  }
}
